/* globals window, document */

import { useFormikContext } from 'formik';
import { useCallback } from 'react';

import { useLocalization } from 'redux/localization/utils/hooks';

const FormErrors = (props) => {
  const { error: errorMessage } = props;
  const { t } = useLocalization();
  const formikContext = useFormikContext();
  const { submitCount } = formikContext;

  const errorRef = useCallback(
    (node) => {
      if (node !== null && submitCount > 0) {
        const c7Checkout = document.getElementById('c7-checkout');
        const form = node.closest('form');

        // The checkout area doesn't use body to scroll, so we scroll c7-content
        if (c7Checkout) {
          const { offsetTop } = form;
          const top = offsetTop - 25;
          const wrapper = document.getElementById('c7-content');

          wrapper.scrollTo({ top, behavior: 'smooth' });
        } else {
          const { top } = form.getBoundingClientRect();
          window.scrollTo({
            top: top + window.scrollY - 25,
            behavior: 'smooth'
          });
        }
      }
    },
    [submitCount]
  );

  const errors = Object.keys(formikContext.errors);
  if (errorMessage) {
    return (
      <div
        className="c7-message c7-message--alert-error"
        role="alert"
        ref={errorRef}
      >
        <p>
          <svg
            aria-hidden="true"
            focusable="false"
            role="presentation"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          {errorMessage}
        </p>
      </div>
    );
  }

  if (errors.length > 0 && submitCount > 0) {
    return (
      <div
        className="c7-message c7-message--alert-error"
        role="alert"
        ref={errorRef}
      >
        <p>
          <svg
            aria-hidden="true"
            focusable="false"
            role="presentation"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          {errors.length > 1
            ? t('general.errorMessages.formErrors')
            : t('general.errorMessages.formError')}
        </p>
      </div>
    );
  }
  return null;
};

export default FormErrors;
